export const ACTIVITYLOGDATA = [
    {
        id:0,
        notiNotRead:false,
        notiType: 'Workflow Created',
        notiDesc: 'New workflow has been created',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Workflow Name:',
        notitypeDesc:'Workflow Description:',
        notitypeNameGot:'UK Workflow',
        notitypeDescGot:'Generic Workflow',
        actionType:'Created By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:1,
        notiNotRead:true,
        notiType: 'Workflow Update',
        notiDesc: ' Workflow has been updated.',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Role Name:',
        notitypeDesc:'Role Description:',
        notitypeNameGot:'Manager ',
        notitypeDescGot:'Generic Workflow',
        actionType:'Created By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:2,
        notiNotRead:true,
        notiType: 'Workflow Deleted',
        notiDesc: ' Workflow has been deleted.',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'User Role:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Manager',
        actionType:'Created By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:3,
        notiNotRead:true,
        notiType: 'Role Added',
        notiDesc: 'Role has been added',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'User Role:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Manager',
        actionType:'Updated By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:4,
        notiNotRead:false,
        notiType: 'Role Deleted',
        notiDesc: 'Role has been deleted',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Invoice Id:  ',
        notitypeDesc:'Client Name:',
        notitypeNameGot:'1234 ',
        notitypeDescGot:'Jacob Bills',
        actionType:'Composed By:',
        actionRole:'Manager',
        actionTypeBy:'Jacob Gill',
    },
    {
        id:5,
        notiNotRead:true,
        notiType: 'Role Updated',
        notiDesc: 'Role has been updated',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'User Role:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Manager',
        actionType:'Deleted By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:6,
        notiNotRead:true,
        notiType: 'User Added',
        notiDesc: 'User has been added',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Role Name:',
        notitypeDesc:'Role Description:',
        notitypeNameGot:'Manager ',
        notitypeDescGot:'Lorem ipsum dolor sit amet consectetur.',
        actionType:'Created By:',
        actionRole:'Admin',
        actionTypeBy:'Jacob Gill',
    },
    {
        id:7,
        notiNotRead:true,
        notiType: 'User Details Updated',
        notiDesc: 'User has been details updated',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Invoice Id',
        notitypeDesc:'Note Description:',
        notitypeNameGot:'1234 ',
        notitypeDescGot:'Lorem ipsum dolor sit amet consectetur. Purus turpis leo sollicitudin vulputate imperdiet bibendum tempor .',
        actionType:'Created By:',
        actionRole:'Manager',
        actionTypeBy:'Clarke  Bill',
    },
    {
        id:8,
        notiNotRead:true,
        notiType: 'User Deleted',
        notiDesc: 'User has been deleted',
        startDate:'07:20 AM',
        endDate:'23 Oct, 2023',
        notitypeName:'Role Name:',
        notitypeDesc:'Role Description:',
        notitypeNameGot:'Manager ',
        notitypeDescGot:'Lorem ipsum dolor sit amet consectetur.',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'Clarke  Bill',
    },
    {
        id:9,
        notiNotRead:true,
        notiType: 'Vendor Added',
        notiDesc: 'New Vendor has been added',
        startDate:'06:20 AM',
        endDate:'22 Oct, 2023',
        notitypeName:'Client Name:',
        notitypeDesc:'Collection Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Paused',
        actionType:'Updated By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:10,
        notiNotRead:true,
        notiType: 'Vendor’s Details Updated',
        notiDesc: 'Vendor’s has been Details Updated',
        startDate:'05:20 AM',
        endDate:'21 Oct, 2023',
        notitypeName:' Workflow Name',
        notitypeDesc:'Client Name:',
        notitypeNameGot:'UK Workflow ',
        notitypeDescGot:'Jacob Bills',
        actionType:'Assigned By:',
        actionRole:'Manager',
        actionTypeBy:'Jacob Gill',
    },
    {
        id:11,
        notiNotRead:true,
        notiType: 'Vendor Deleted',
        notiDesc: 'New Vendor has been deleted',
        startDate:'09:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:12,
        notiNotRead:true,
        notiType: 'Bill Approved',
        notiDesc: 'Bill has been approved',
        startDate:'10:20 AM',
        endDate:'29 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:13,
        notiNotRead:true,
        notiType: 'Bill Added',
        notiDesc: 'Bill has been added',
        startDate:'04:20 AM',
        endDate:'20 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:14,
        notiNotRead:true,
        notiType: 'Bill Decline',
        notiDesc: 'Bill has been decline',
        startDate:'01:20 PM',
        endDate:'09 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:15,
        notiNotRead:true,
        notiType: 'Bill Updated',
        notiDesc: 'Bill has been update',
        startDate:'09:20 PM',
        endDate:'01 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:16,
        notiNotRead:true,
        notiType: 'Bill Deleted',
        notiDesc: 'Bill has been deleted',
        startDate:'04:20 PM',
        endDate:'15 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:17,
        notiNotRead:true,
        notiType: 'Credit Note Added',
        notiDesc: 'New Credit Note has been added.',
        startDate:'05:20 AM',
        endDate:'01 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Vendor Name:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Antony',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:18,
        notiNotRead:true,
        notiType: 'Credit Note Updated',
        notiDesc: 'Credit Note has updated.',
        startDate:'04:20 PM',
        endDate:'11 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Vendor Name:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:19,
        notiNotRead:true,
        notiType: 'Credit Note Deleted',
        notiDesc: 'Credit Note has deleted.',
        startDate:'04:20 AM',
        endDate:'09 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Vendor Name:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:20,
        notiNotRead:true,
        notiType: 'Payment Source Added',
        notiDesc: 'New Payment Source has been added.',
        startDate:'05:20 PM',
        endDate:'20 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:21,
        notiNotRead:true,
        notiType: 'Payment Source Updated',
        notiDesc: 'Payment Source has been updated.',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:21,
        notiNotRead:true,
        notiType: 'Payment Source Deleted',
        notiDesc: 'Payment Source has been deleted.',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:22,
        notiNotRead:true,
        notiType: 'Receipt Uploaded',
        notiDesc: 'New Receipt has been uploaded.',
        startDate:'01:20 AM',
        endDate:'11 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Vendor Name:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'john',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:23,
        notiNotRead:true,
        notiType: 'Receipt Deleted',
        notiDesc: 'Receipt has been deleted.',
        startDate:'03:20 AM',
        endDate:'16 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Vendor Name:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'john',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:24,
        notiNotRead:true,
        notiType: 'Access Rights Updated',
        notiDesc: 'Role’ Rights have been updated',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'Role Description:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Lorem ipsum dolor sit amet consectetur.',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:25,
        notiNotRead:true,
        notiType: 'Access Control Updated',
        notiDesc: 'User Access Control has been updated',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        furtherDetailNotitypeName:'User Role : Manager ',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
]